/**@jsx jsx */
import { jsx, Box, Flex, Image } from 'theme-ui'
import { useEffect, useState } from 'react'
import Layout from './layout'
import Roles from './company_landing/roles'
import Socials from './company_landing/socials'
import SEO from '../components/seo'
import { baseUrl } from '../cloudinary-transforms'
import { MDXProvider } from '@mdx-js/react'
import { YouTube, Vimeo } from 'mdx-embed'

import { MDXRenderer } from 'gatsby-plugin-mdx'
import Sparkles from './sparkles'

const CompanyLanding = ({ frontmatter, mdx }) => {
  const {
    banner,
    blurb,
    logo,
    company_name,
    roles,
    company_website,
    company_facebook,
    company_linkedin,
    company_twitter,
    company_insta,
    meta_image,
  } = frontmatter

  const [pointlessState, setPointlessState] = useState(null)

  useEffect(() => {
    setTimeout(() => {
      setPointlessState('derp')
    }, 100)
  }, [])

  function videoCheck(link) {
    if (link.includes('youtube')) {
      return <YouTube youTubeId={link.split('=')[1]} />
    } else {
      return <Vimeo vimeoId={link.split('/')[3]} />
    }
  }

  return (
    <MDXProvider
      components={{
        p: (props) => (
          <p
            {...props}
            sx={{
              fontSize: ['12px', '14px'],
              fontFamily: 'body',
              lineHeight: ['20pt', '24pt'],
              letterSpacing: '1px',
              marginTop: '24pt',
              color: 'darkGrey',
            }}
          />
        ),
        strong: (props) => <strong sx={{ color: 'text' }} {...props} />,
        h3: (props) => (
          <h3
            {...props}
            sx={{
              marginTop: '24pt',
              marginBottom: '10pt',
              fontSize: '24px',
              letterSpacing: '2px',
            }}
          />
        ),
        img: (props) => (
          <Sparkles>
            <Image {...props} aria-hidden={'true'} role="presentation" />
          </Sparkles>
        ),
        ol: (props) => (
          <ol
            sx={{
              color: 'darkGrey',
              fontSize: '14px',
              lineHeight: ['20pt', '24pt'],
            }}
            {...props}
          />
        ),
        ul: (props) => (
          <ul
            sx={{
              color: 'darkGrey',
              fontSize: ['12px', '14px'],
              marginBottom: '40pt',
              lineHeight: ['20pt', '24pt'],
            }}
            {...props}
          />
        ),
        li: (props) => {  
          return <li {...props}><p sx={{margin:0}}>{props.children}</p></li>},
        video: (props) => {
          return videoCheck(props.children)
        },
        h6: (props) => {
          return <h6 {...props} sx={{marginTop: '24pt'}}>{props.children}</h6>
        }
      }}
    >
      <Layout>
        <SEO
          title={`Jobs at ${company_name}`}
          description={blurb}
          image={meta_image ? baseUrl + meta_image : null}
        />
        <Box sx={{ marginBottom: '40px' }}>
          <Flex
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <div
              className="heading-text"
              sx={{
                alignItems: 'center',
                textAlign: 'center',
                marginBottom: '50px',
              }}
            >
              {banner ? (
                <Image
                  alt={{ company_name }}
                  sx={{ width: '100%' }}
                  src={baseUrl + banner}
                />
              ) : (
                <Image
                  alt={company_name}
                  sx={{
                    width: '200px',
                    marginTop: '20px',
                    marginBottom: '20px',
                  }}
                  src={baseUrl + logo}
                />
              )}
              <h1>{company_name}</h1>
              <Socials
                company_facebook={company_facebook}
                company_insta={company_insta}
                company_linkedin={company_linkedin}
                company_twitter={company_twitter}
                company_website={company_website}
              />
              <div sx={{ width: '75%', margin: 'auto', textAlign: 'left' }}>
                <p sx={{ fontSize: '15px', padding: 20 }}>{blurb}</p>
              </div>
            </div>
            <div className="container">
              <span>{`Open roles at ${company_name} : ${roles.length}`}</span>

              {company_name === 'Instagram' && (
                <p>
                  <strong>
                    *Please also reach out to cwads@fb.com after submitting your
                    job application via the links
                  </strong>
                </p>
              )}
              {company_name === 'Lyft Inc.' && (
                <p>
                  <strong>
                    *Lyft is hiring on-site at their locations in San Francisco,
                    New York, Seattle, Nashville, and remotely! Additionally,
                    Lyft is now a fully flexible workplace. Almost all new and
                    existing team members will now have the choice of where to
                    live and where to work — Lyft employees can choose to work
                    from the office, at home, or any combination of the two. We
                    also believe in and support an extraordinary office
                    experience that brings people together intentionally and
                    organically, without set days or obligations.
                  </strong>
                </p>
              )}
              {company_name === 'WM Technology' && (
                <div>
                  <p>
                    <strong>
                      Notice to prospective Weedmaps job applicants:
                    </strong>
                  </p>

                  <p>
                    <strong>
                      Our team has been made aware of incidents involving
                      LinkedIn, Telegram, and Facebook accounts impersonating
                      Weedmaps recruiters. These individuals are attempting to
                      use our company name to solicit payment from prospective
                      candidates interested in applying for jobs at our company.
                      Our team is actively working to combat these attempts, but
                      in the meantime, please be mindful that our recruiters
                      will always communicate with candidates through a
                      @weedmaps.com email address.
                    </strong>
                  </p>
                </div>
              )}
              <Roles roles={roles} />
            </div>

            <Box
              sx={{
                backgroundColor: '#f8f9fa',
                paddingLeft: ['10px', '60px'],
                marginTop: '32px',
                paddingTop: ['20px', '40px'],
              }}
              className="container"
            >
              <Box sx={{ maxWidth: '700px', zIndex: '-2' }}>
                <MDXRenderer>{mdx.body}</MDXRenderer>
              </Box>
            </Box>
          </Flex>
        </Box>
      </Layout>
    </MDXProvider>
  )
}

export default CompanyLanding
